import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Seo } from "../components/Seo";
import { api, formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-antracite flex items-center justify-center px-6" data-testid="admin-login-page">
      <Seo title="Area riservata | V32 Group" noindex />
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <p className="font-display font-semibold text-3xl text-avorio tracking-tight">
            V32 <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-pietra align-middle">Group</span>
          </p>
          <p className="mt-3 font-mono text-xs uppercase tracking-[0.25em] text-bronzo">Area riservata</p>
        </div>
        <form onSubmit={submit} className="bg-avorio p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label htmlFor="a-email" className="block font-mono text-[11px] uppercase tracking-[0.18em] text-ink/60 mb-2">Email</label>
            <input
              id="a-email"
              data-testid="admin-email-input"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-ink/15 px-4 py-3 text-sm text-ink focus:outline-none focus:border-bronzo transition-colors duration-300"
            />
          </div>
          <div>
            <label htmlFor="a-password" className="block font-mono text-[11px] uppercase tracking-[0.18em] text-ink/60 mb-2">Password</label>
            <input
              id="a-password"
              data-testid="admin-password-input"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white border border-ink/15 px-4 py-3 text-sm text-ink focus:outline-none focus:border-bronzo transition-colors duration-300"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-2.5">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-antracite text-avorio font-medium py-3.5 hover:bg-bronzo disabled:opacity-50 transition-colors duration-300"
          >
            {loading ? "Accesso in corso…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
